import React from 'react';
import { useSelector } from 'react-redux';
import { SizeableText, Typography } from 'fronton-react';
import { selectWindowType, TWindowType } from 'store/pageStore';
import { TConfigurator } from '../../../../types';
import { CardPrice } from '../card-price';
import { CardWrapper, ContentWrapper } from '../styled';
import { measureCardPrice, titleStyles, measureCard } from './styled';
import { useAnalytics } from '../hooks';
import { selectCompensationStatus, selectMeasureDeadline } from '../../../../selectors';
import { getDeadlineText } from '../../../../../../utils';
import { CompensationAlert } from './compensation-alert';

const getTitleVariant = (windowType: TWindowType): SizeableText => {
	switch (windowType) {
		case 'mobile':
			return 's';
		default:
			return 'm';
	}
};

type MeasureCardProps = {
	configurator: TConfigurator;
	wide: boolean;
};

export const MeasureCard = ({ configurator, wide }: MeasureCardProps) => {
	const windowType = useSelector(selectWindowType);
	const titleVariant = getTitleVariant(windowType);

	const { name, pageUrl, price, measurementUnit, isPriceStatic } = configurator;
	const { ref, analyticsClickHandler } = useAnalytics(configurator);

	const deadlineDays = useSelector(selectMeasureDeadline) || 3;
	const deadlineText = `${deadlineDays}\u00A0${getDeadlineText(deadlineDays, true)}`;

	const isCompensationEnabled = useSelector(selectCompensationStatus);

	return (
		<CardWrapper
			ref={ref}
			className={measureCard}
			href={pageUrl}
			onClick={analyticsClickHandler}
			wide={wide}
		>
			<ContentWrapper>
				<div>
					<Typography
						variant={titleVariant}
						size="body_accent"
						as="h3"
						className={titleStyles}
						data-qa="measure-title"
						data-analyticsName="productNameLink"
					>
						{name}
					</Typography>
					<Typography
						variant="s"
						size="body_short"
						as="p"
						data-qa="measure-description"
						data-analyticsName="productDescriptionLink"
					>
						Срок выполнения Замера&nbsp;— {deadlineText}
					</Typography>
					{isCompensationEnabled && <CompensationAlert />}
				</div>
				<CardPrice
					price={price}
					className={measureCardPrice}
					unit={measurementUnit}
					flexiblePrice={!isPriceStatic}
				/>
			</ContentWrapper>
		</CardWrapper>
	);
};
